import React from 'react';
import Header from './Header';
import Footer from './Footer';

const SuccessPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-6 sm:mb-8">
            <span className="text-5xl sm:text-6xl">🎉</span>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mt-3 sm:mt-4 mb-4 sm:mb-6">
              Success! 🎉
            </h1>
          </div>
          
          <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8">
            I'm very happy to see your interest in Practice Dashboard - your new Automated Admin Agent!
          </p>
          
          <div className="mb-6 sm:mb-8">
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-3 sm:mb-4 underline">
              What Happens Next?
            </h2>
            
            <div className="text-left bg-gray-50 rounded-lg p-4 sm:p-6">
              <p className="text-sm sm:text-base text-gray-700 mb-3 sm:mb-4">
                I will be in touch shortly to schedule a personalized demo and a discussion about how we can 
                tailor Practice Dashboard to meet your unique needs. I can't wait to connect with you and take 
                the first steps toward a solution that will become your favorite everyday tool :) Until then, feel 
                free to{' '}
                <a href="/contact" className="text-orange-500 hover:text-orange-600 underline">
                  reach out
                </a>{' '}
                if there's anything specific you'd like me to prepare for the call.
              </p>
            </div>
          </div>
          
          <div className="text-center">
            <p className="text-sm sm:text-base text-gray-600 mb-2">Excited to chat,</p>
            <p className="font-semibold text-gray-900 text-base sm:text-lg">Pavlo Martinovych</p>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default SuccessPage;